import { CompactButton } from '@/components/buttons';
import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { CurbyAccordion } from '@/components/curby-accordion';
import { CustomContentSection } from '@/components/custom-content-section';
import { PrimaryLayout } from '@/layouts/primary';
import { Flex, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';
import {
	AccordionLocation,
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';
import styles from './styles.module.css';

export const AppUpdatesPage = () => {
	const navigate = useNavigate();
	const backToHome = useCallback(() => navigate({ to: '/home' }), [navigate]);
	const closeButton = useMemo(
		() => (
			<CompactButton onClick={backToHome} leftSection={<IconX />}>
				Close
			</CompactButton>
		),
		[backToHome]
	);
	const continueButton = useMemo(
		() => <StandardButton onClick={backToHome}>Continue</StandardButton>,
		[backToHome]
	);

	return (
		<PrimaryLayout
			header={{ title: 'Updates', children: closeButton }}
			footer={{ children: continueButton }}
		>
			<ContentPanel>
				<Flex direction="column" gap="md" align="flex-start">
					<CustomContentSection
						location={ContentSectionLocation.AppUpdates}
						placement={ContentSectionPlacement.Top}
					/>
					<Text size="xl" fw={900} className={styles.welcome} p="lg">
						Welcome to the new Curby app!
					</Text>
					<CustomContentSection
						location={ContentSectionLocation.AppUpdates}
						placement={ContentSectionPlacement.Middle}
					/>
					<CurbyAccordion
						title="Outline of Changes"
						accordionLocation={AccordionLocation.AppUpdates}
					/>
					<CustomContentSection
						location={ContentSectionLocation.AppUpdates}
						placement={ContentSectionPlacement.Bottom}
					/>
				</Flex>
			</ContentPanel>
		</PrimaryLayout>
	);
};
